import axios from '@axios'

export default {
  namespaced: true,
  state: {
    countries: [],
    request_is_success: null,
    request_error_msg: null,
  },
  getters: {
    getCountries: state => state.countries,
    getRequestStatus: state => state.request_is_success,
    getRequestErrorMsg: state => state.request_error_msg,
  },
  mutations: {
    set_on_request_success(state, payload) {
      state.countries = payload
      state.request_is_success = true
      state.request_error_msg = null
    },
    set_on_request_error(state, error) {
      state.countries = []
      state.request_is_success = false
      state.request_error_msg = error
    },
  },
  actions: {
    fetchCountries({ commit }) {
      return new Promise((resolve, reject) => {
        axios({
          method: 'get',
          url: '/api/v1/countries/',
        })
          .then(response => {
            if (response.status === 200) {
              commit('set_on_request_success', response.data)
              resolve(response)
            }
          })
          .catch(error => {
            reject(error)
          })
      })
    },
  },
}
